import { render, staticRenderFns } from "./PointTiers.vue?vue&type=template&id=631e44b5&scoped=true"
import script from "./PointTiers.vue?vue&type=script&lang=js"
export * from "./PointTiers.vue?vue&type=script&lang=js"
import style0 from "./PointTiers.vue?vue&type=style&index=0&id=631e44b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e44b5",
  null
  
)

export default component.exports